const ibanRegex = /^[a-zA-Z]{2}\d{2}\s*(\w{4}\s*){2,7}\w{1,4}\s*$/i;

/**
 *  Pure validation function returning a boolean
 *
 *  To check it online: https://wise.com/gb/iban/checker
 *  The code here only checks a basic regex + checksum.
 *
 */
export function validateIban(value: string): boolean {
    const formatValid = ibanRegex.test(value);

    const checksumValid = formatValid && checksum(value);

    return formatValid && checksumValid;
}

function checksum(value: string): boolean {
    // Remove spaces and convert to uppercase
    const cleanIban = value.replace(/\s/g, '').toUpperCase();

    // Move first 4 characters to the end
    const rearranged = cleanIban.slice(4) + cleanIban.slice(0, 4);

    // Replace letters with numbers (A=10, B=11, ..., Z=35)
    const numericString = rearranged.replace(/[A-Z]/g, (char) => {
        return (char.charCodeAt(0) - 55).toString();
    });

    // Calculate mod 97
    const remainder = mod97(numericString);

    return remainder === 1;
}

/**
 * Computes the remainder of a numeric string divided by 97 using the MOD 97 algorithm.
 * This function operates on large numeric strings by processing one digit at a time, avoiding
 * issues with number precision in JavaScript for very large integers without adding any additional library.
 *
 * @param {string} numericString - The numeric string to be reduced modulo 97.
 * Must consist only of numeric characters (0-9).
 * @return {number} The remainder when the numeric string is divided by 97.
 */
function mod97(numericString: string): number {
    let remainder = 0;
    for (let i = 0; i < numericString.length; i++) {
        remainder = (remainder * 10 + parseInt(numericString[i] || '0')) % 97;
    }
    return remainder;
}
